import { Capacitor } from '@capacitor/core'
import { AppInfo, App as CapacitorApp } from '@capacitor/app'
import { Device } from '@capacitor/device'
import { SyncStrategy } from '@fusion-advantage/formlib';

let appInfo: AppInfo|null = null;
(async() => {
	if(Capacitor.isNativePlatform()) {
		appInfo = await CapacitorApp.getInfo()
	}
})()
let iosVersion: number|null = null;
(async () => {
	if(!import.meta.env.VITEST) {
		iosVersion = (await Device.getInfo()).iOSVersion ?? null
	}
})()

export const getAppInfo = () => appInfo
export const getBuildNumber = () => appInfo ? parseInt(appInfo.build) : null
export const getIosVersion = () => iosVersion
export const hasMinimumIosVersion = (): boolean => {
	if(Capacitor.getPlatform() !== 'ios') {
		return true
	}
	// minimum iOS 18.2 required for .toBase64()
	if(iosVersion && iosVersion >= 180200) {
		return true
	}
	return false
}
// these values filled in according to
// webpack.mix.js (mix) and main.js (storybook)
export const getJsBundle = () => import.meta.env.BUILDTIME ? import.meta.env.BUILDTIME : null
export const getApiBaseUrl = () => import.meta.env.VITEST ? 'http://test.test' : 'https://' + import.meta.env.MIX_API_DOMAIN
// the API domain baked in at build time— unlike the environment reported by
// /api/v0/status, this is available before login and reflects what this
// build actually calls, so a mislabelled build can be spotted on the device
export const getApiDomain = (): string|null => import.meta.env.MIX_API_DOMAIN ?? null
export const getCopyright = () => `© ${new Date().getFullYear()} Fusion Health Group`
export const getLongCopyright = () => `© 2023-${new Date().getFullYear()} Fusion Health Group`
export const getDefaultSyncStrategy = () => Capacitor.isNativePlatform() ? SyncStrategy.Mobile : SyncStrategy.Online
